/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmUserPhoneRequest
 */
export interface ConfirmUserPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmUserPhoneRequest
     */
    confirmationCode: string;
}

/**
 * Check if a given object implements the ConfirmUserPhoneRequest interface.
 */
export function instanceOfConfirmUserPhoneRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confirmationCode" in value;

    return isInstance;
}

export function ConfirmUserPhoneRequestFromJSON(json: any): ConfirmUserPhoneRequest {
    return ConfirmUserPhoneRequestFromJSONTyped(json, false);
}

export function ConfirmUserPhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmUserPhoneRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confirmationCode': json['confirmation_code'],
    };
}

export function ConfirmUserPhoneRequestToJSON(value?: ConfirmUserPhoneRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confirmation_code': value.confirmationCode,
    };
}

